<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import AdminCreateModalForm from '../AdminCreateModalForm/AdminCreateModalForm.vue';

export default Vue.extend({
    components: {
        AdminCreateModalForm
    },
    computed: {
        ...mapState({
            open: state => state.admin.createModal.open
        })
    },
    methods: {
        ...mapActions({
            toggleCreateModal: 'admin/toggleCreateModal'
        }),
        toggleModal($event) {
            if($event.target.id === 'container') {
                this.toggleCreateModal();
            }
        }
    }
});
</script>
<template>
    <transition name="fade" mode="out-in">
        <div v-if="open" class="admin-create-modal">
            <div id="container" class="admin-create-modal__container" @click="toggleModal($event)">
                <div class="admin-create-modal__content">
                    <div class="admin-create-modal__header">
                        <div class="admin-create-modal__heading">
                            {{ $t('admin.create.header.heading') }}
                        </div>
                        <div class="manage-allocation-modal__toggle" @click="toggleCreateModal()">
                            <i class="fa fa-times-circle"/>
                        </div>
                    </div>
                    <div class="admin-create-modal__body">
                        <admin-create-modal-form/>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>



// WEBPACK FOOTER //
// src/components/AdminCreateModal/AdminCreateModal.vue